module.exports = __webpack_public_path__ + "static/img/done.17b1e870.svg";